// @flow
import React, { Component } from 'react'
import { translations, translateFunc } from '../../shared/localize'
import HintWrapper from '../controls/HintWrapper'
import _ from 'lodash'
import LabeledWrapper from './LabeledWrapper'

export type Props = {|
  maxAge?: number | void,
  minAge?: number | void,
  minAgeLimit: number,
  maxAgeLimit: number,
  errors: Array<string>,
  onMaxAgeChange: (number | null) => void,
  onMinAgeChange: (number | null) => void
|}

export default class AgeRange extends Component<Props> {
  t: Function

  constructor(props: Props) {
    super(props)

    this.t = translateFunc(translations.age_range)
  }

  render() {
    const { minAgeLimit, maxAgeLimit, errors } = this.props

    return (
      <LabeledWrapper
        label={
          <div>
            {this.t('label')}
            <div className="label-hint">
              <HintWrapper
                triggerText={this.t('hint', {
                  min_age: minAgeLimit,
                  max_age: maxAgeLimit
                })}
                popupText={this.t('description', {
                  min_age: minAgeLimit,
                  max_age: maxAgeLimit
                })}
                alignLeft
                dashed
              />
            </div>
          </div>
        }
        errors={errors}
        twoLines
      >
        <span>{this.t('from')} </span>
        <span className={this.wrapperClass()}>
          <input
            id="audience_min_age"
            type="text"
            maxLength={2}
            size={2}
            className="input-item input-item_small"
            value={this.props.minAge || ''}
            onChange={(e) => this.minAgeChanged(e)}
          />
        </span>
        <span> {this.t('to')} </span>
        <span className={this.wrapperClass()}>
          <input
            id="audience_max_age"
            type="text"
            maxLength={2}
            size={2}
            className="input-item input-item_small"
            value={this.props.maxAge || ''}
            onChange={(e) => this.maxAgeChanged(e)}
          />
        </span>
      </LabeledWrapper>
    )
  }

  wrapperClass() {
    if (!_.isEmpty(this.props.errors)) return 'field_with_errors'
  }

  minAgeChanged(e: Object) {
    let minAge = this.parseStringValue(e.target.value)
    this.props.onMinAgeChange && this.props.onMinAgeChange(minAge)
  }

  maxAgeChanged(e: Object) {
    let maxAge: null | number = this.parseStringValue(e.target.value)
    this.props.onMaxAgeChange && this.props.onMaxAgeChange(maxAge)
  }

  parseStringValue(s: string): number | null {
    s = s.replace(/[^0-9]/, '')

    return s === '' ? null : parseInt(s)
  }
}
